import { render, staticRenderFns } from "./GerenciaPedidos.vue?vue&type=template&id=78f01878"
import script from "./GerenciaPedidos.vue?vue&type=script&lang=js"
export * from "./GerenciaPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports